import React, { useState } from "react";
import { get, post } from "../Api/HttpClient";



const useFetch = (url, method, isParam, isFormData) => {
    const [response, setResponse] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null)

    //main function for fetch requests. also handling loaders and errors
    //callBack param is your callback function
    const doFetch = async (body, callBack, formData) => {
        setIsLoading(false)
        //Params handling
        const handleUrl = isParam ? `${url}?${new URLSearchParams(body).toString()}` : url

        //GET method
        if(method == "get") {
            await get(handleUrl).then(
                (res) => {if(res) {setResponse(res); if(callBack) callBack(res)}}
            ).finally(
                () => setIsLoading(true)
            ).catch(
                (err) => setError(err)
            )
        }
        //POST method
        if(method == "post") {
            await post(handleUrl, ((isParam ? undefined : body) || formData ? formData : undefined), isFormData).then(
                (res) => {if(callBack) callBack(res)}
            ).finally(
                () => setIsLoading(true)
            ).catch(
                (err) => setError(err)
            )
        }
    }

    return [{ response, isLoading, error }, doFetch]
}

export default useFetch